import axiosInstance from "core/api/axiosInstance";
import { normalizeCerberusLogs } from "../cerberus/model/cerberusModel";

export const getViewLogsListService = async (params = {}, options = {}) => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/log/get-view-logs", {
      params,
      ...(options.signal ? { signal: options.signal } : {}),
    });
    const logs = normalizeCerberusLogs(data);
    return {
      success: true,
      data: logs,
      total: logs.length,
      message: data.msm || "Registros obtenidos correctamente",
    };
  } catch (error) {
    if (error.code === "ERR_CANCELED" || error.name === "AbortError")
      return { success: false, cancelled: true, data: [], total: 0 };
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.response?.data?.msm ||
        (error.request ? "No se pudo conectar con el servidor." : error.message) ||
        "No se pudo cargar Cerberus.",
      data: [],
      total: 0,
    };
  }
};

export const getViewLogsService = async (params = {}, options = {}) => {
  const result = await getViewLogsListService(params, options);
  return { ...result, data: result.success ? result.data[0] ?? null : null };
};

export default { getViewLogs: getViewLogsService, getViewLogsList: getViewLogsListService };
